<template>
  <div class="youtube-player">
    <iframe
      v-bind:src="url"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
  </div>
</template>

<script>
  export default {
    name: 'YoutubePlayer',
    props: {
      url: {
        type: String,
        required: true,
      }
    }
  };
</script>

<style lang="scss">
  .youtube-player {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;

    iframe {
      border: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>
